import React from 'react';

const ShimmerEffect = ({ 
  width = '100%', 
  height = '20px', 
  borderRadius = '4px',
  className = '',
  style = {} 
}) => {
  return (
    <div
      className={`shimmer-effect ${className}`}
      style={{
        width,
        height,
        borderRadius,
        background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
        backgroundSize: '200% 100%',
        animation: 'shimmer 1.5s infinite',
        ...style
      }}
    />
  );
};

// Shimmer Loading Spinner for buttons and small areas
export const ShimmerSpinner = ({ 
  size = 16, 
  color = '#ffffff',
  style = {} 
}) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: `linear-gradient(90deg, ${color}40 25%, ${color}80 50%, ${color}40 75%)`,
        backgroundSize: '200% 100%',
        animation: 'shimmer 1.5s infinite',
        ...style
      }}
    />
  );
};

// Shimmer Card for content placeholders
export const ShimmerCard = ({ 
  width = '100%', 
  height = '120px', 
  className = '',
  style = {} 
}) => {
  return (
    <div
      className={`shimmer-card ${className}`}
      style={{
        width,
        height,
        borderRadius: '8px',
        background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
        backgroundSize: '200% 100%',
        animation: 'shimmer 1.5s infinite',
        ...style
      }}
    />
  );
};

// Shimmer Text lines
export const ShimmerText = ({ 
  lines = 1, 
  width = '100%',
  height = '16px',
  gap = '8px',
  style = {} 
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap, ...style }}>
      {Array.from({ length: lines }).map((_, index) => (
        <ShimmerEffect
          key={index}
          width={Array.isArray(width) ? width[index] || '100%' : width}
          height={height}
          borderRadius="4px"
        />
      ))}
    </div>
  );
};

// Add CSS animation to the document if it doesn't exist
if (typeof document !== 'undefined' && !document.querySelector('#shimmer-keyframes')) {
  const style = document.createElement('style');
  style.id = 'shimmer-keyframes';
  style.textContent = `
    @keyframes shimmer {
      0% {
        background-position: -200% 0;
      }
      100% {
        background-position: 200% 0;
      }
    }
  `;
  document.head.appendChild(style);
}

export default ShimmerEffect;
